import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import React, { useCallback, useContext, useMemo } from "react";
import Cookies from "universal-cookie";
import { COOKIE_SESSION_NAME, SESSION_STORAGE_TOKEN } from "../constants";
import { UserContext } from "../contexts/user";
import { useSessionStorage } from "../hooks/use-session-storage";
var useStyles = makeStyles(function(theme) {
    return {
        alignRight: {
            textAlign: "right"
        },
        light: {
            color: theme.palette.getContrastText("#fff")
        },
        dark: {
            color: theme.palette.getContrastText(theme.palette.primary.main)
        },
        text: {
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            overflow: "hidden"
        },
        loggedInInfo: {
            lineHeight: "90%"
        },
        loggedInEmail: {
            fontSize: 10
        },
        assumedSpan: {
            marginTop: -1,
            color: theme.palette.secondary.main,
            fontSize: 10,
            verticalAlign: "middle",
            "&:hover, &:hover *": {
                color: theme.palette.getContrastText(theme.palette.primary.main),
                cursor: "pointer"
            }
        }
    };
});
// NOTE: This is simply a hacky way to figure out if the user has a session (not to mistake assumed sessions for
// dashboards). If we attempt to set a new value for accessToken which is httpOnly some browsers ignore the operation if
// the cookie already exists. We cannot read the cookie itself because it's httpOnly.
var existingSession = function(uc) {
    uc.set("accessToken", "test", {
        path: "/"
    });
    return uc.get("accessToken") ? (uc.remove("accessToken"), false) : true;
};
var UserInfo = function(param) {
    var className = param.className, backgroundTone = param.backgroundTone, alignRight = param.alignRight;
    var tone = backgroundTone || "dark";
    var classes = useStyles();
    var user = useContext(UserContext);
    var uc = useMemo(function() {
        return new Cookies();
    }, []);
    var ref = _sliced_to_array(useSessionStorage(SESSION_STORAGE_TOKEN, undefined), 2), token = ref[0], setToken = ref[1];
    var isAssumed = token && existingSession(uc);
    var clearToken = useCallback(function() {
        setToken(undefined);
        uc.remove(COOKIE_SESSION_NAME);
        location.reload();
    }, [
        setToken
    ]);
    if (!user.sub) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        className: clsx(className, classes.loggedInInfo, classes[tone], classes.text, alignRight && classes.alignRight)
    }, isAssumed ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Tooltip, {
        title: "Drop session"
    }, /*#__PURE__*/ React.createElement("span", {
        onClick: clearToken,
        className: classes.assumedSpan
    }, "Assumed ", /*#__PURE__*/ React.createElement(CloseIcon, {
        className: classes.assumedSpan
    }))), /*#__PURE__*/ React.createElement("br", null)) : null, user.givenName, " ", user.familyName, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("span", {
        className: classes.loggedInEmail
    }, user.email)));
};
export default UserInfo;
